let roles = [];

fetch(`${import.meta.env.VITE_API_URL}/api/data/roles.php`).then(response => {
    response.json().then(data => {
        for (let role of data) {
            roles.push(role);
        }
        // console.log("roles", roles);
    });
});

export default roles;